// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"e2e6149c","262":"f1f56eeb","661":"e2e6149c"}[chunkId] + ".chunk.css";
};